import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import { RootState } from '../../app/store';
import { setUserToLS } from '../../helpers/localstorage-helper';
import {
  changeAvailableLoyaltyPoints,
  changeAvailableRewardPoints,
  changeAvailableShoppingPoints,
  updateVirtualOfficeLicence
} from '../../slices/auth-slice';

import { PurchaseSteps } from './Maeketplace.types';
import {
  addHubAsync,
  getGoldenCardAsync,
  getGoldenCardStatusAsync,
  getSuperSalesLicencesAsync,
  getTravelPackagesAsync,
  getTravelutionSubscriptionBundleAsync,
  getTravelutionSubscriptionsAsync,
  purchaseGoldenCardAsync,
  purchaseSubscriptionAsync,
  purchaseSubscriptionBundleAsync,
  purchaseSuperSalesAsync,
  purchaseTravelPackageAsync
} from './Marketplace.requests';
import { ErrorToast } from '../../components';
import axios from 'axios';

export const getTravelPackages = createAsyncThunk(
  'getTravelPackages',
  async () => {
    const { data } = await getTravelPackagesAsync();

    let packages = data!.products;

    const newHubs = packages.map((hub) => {
      return {
        ...hub,
        id: hub.id,
        title: hub.name,
        willyMemeCoins: hub.price,
        tickets: `+${hub.tickets} ${hub.tickets !== 5 ? 'ticket' : 'tickets'}`,
        type: 2
      };
    });

    return {
      hubs: newHubs as any,
      userPackages: []
    };
  }
);

export const getTravelutionSubscriptions = createAsyncThunk(
  'getTravelutionSubscriptions',
  async () => {
    const { data } = await getTravelutionSubscriptionsAsync();

    let packages = data!.products;

    const newHubs = packages.map((hub: any) => {
      return {
        ...hub,
        id: hub.id,
        packageId: hub.id,
        title: hub.name,
        subtitle: `+ ${hub.myLifePoints}`,
        willyMemeCoins: hub.price,
        tickets: 'MYLIFE POINTS',
        type: 7
      };
    });

    return {
      hubs: newHubs as any,
      userPackages: []
    };
  }
);

export const getGoldenCard = createAsyncThunk('getGoldenCard', async () => {
  const { data } = await getGoldenCardAsync();

  const products = data.products.map((product: any, index: number) => {
    return {
      ...product,
      type: 9
    };
  });
  return products;
});

export const getGoldenCardStatus = createAsyncThunk(
  'getGoldenCardStatus',
  async () => {
    const { data } = await getGoldenCardStatusAsync();

    return data.status;
  }
);

export const getTravelutionSubscriptionBundle = createAsyncThunk(
  'getTravelutionSubscriptionBundle',
  async () => {
    const { data } = await getTravelutionSubscriptionBundleAsync();

    const products = data.products.map((product: any, index: number) => {
      return {
        ...product,
        type: 8
      };
    });

    return products;
  }
);

export const getSuperSalesLicences = createAsyncThunk(
  'getSuperSalesLicences',
  async () => {
    const { data } = await getSuperSalesLicencesAsync();

    const products = data.products.map((product: any, index: number) => {
      return {
        ...product,
        type: 10
      };
    });

    return products;
  }
);

export const payTravelutionSubscription = createAsyncThunk(
  'payTravelutionSubscription',
  async (
    {
      packageId,
      currencyType,
      networkType,
      licenceId,
      userDiscountCodeId,
      step,
      setStep
    }: {
      packageId: number;
      currencyType: number;
      networkType: number | null;
      licenceId: number | null;
      userDiscountCodeId: number | null;
      step: number;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      const { data } = await addHubAsync({
        packageId,
        currencyType,
        networkType,
        licenceId,
        userDiscountCodeId
      });

      const state = getState() as RootState;

      setStep(step);

      if (currencyType === 3) {
        dispatch(
          changeAvailableRewardPoints(data!.userTickets.availableRewardPoints)
        );
      } else if (currencyType === 2) {
        dispatch(
          changeAvailableShoppingPoints(data!.userTickets.shoppingPoints)
        );
      } else if (currencyType === 4) {
        dispatch(changeAvailableLoyaltyPoints(data!.userTickets.loyaltyPoints));
      }

      if (licenceId !== null) {
        dispatch(updateVirtualOfficeLicence(data!.userVirtualOfficeLicence));

        const user = {
          ...state.auth.userInfo,
          user: {
            ...state.auth.userInfo.user,
            userTickets: data!.userTickets,
            currentVirtualOfficeLicence: data!.userVirtualOfficeLicence
          }
        };

        setUserToLS(user);
      } else {
        const user = {
          ...state.auth.userInfo,
          user: {
            ...state.auth.userInfo.user,
            userTickets: data!.userTickets
          }
        };

        setUserToLS(user);
      }

      return {
        userPackage: data!.userPackage,
        currencyType
      };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const purchasePackage = createAsyncThunk(
  'purchasePackage',
  async (
    {
      productId,
      email
    }: {
      productId: number;
      email: string;
    },
    { dispatch }
  ) => {
    try {
      const { data } = await purchaseTravelPackageAsync({
        productId,
        email
      });

      dispatch(setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_PAGE }));
      return data.order.id;
    } catch (error: any) {
      setPurchaseCardStep({ step: PurchaseSteps.FAILED });
    }
  }
);

export const purchaseSubscription = createAsyncThunk(
  'purchaseSubscription',
  async (
    { productId, email }: { productId: number; email: string },
    { dispatch }
  ) => {
    try {
      const { data } = await purchaseSubscriptionAsync({
        productId,
        email
      });

      dispatch(setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_PAGE }));
      return data.order.id;
    } catch (error: any) {
      setPurchaseCardStep({ step: PurchaseSteps.FAILED });
    }
  }
);

export const purchaseGoldenCard = createAsyncThunk(
  'purchaseGoldenCard',
  async (
    {
      productId,
      email
    }: {
      productId: number;
      email: string;
    },
    { dispatch }
  ) => {
    try {
      const { data } = await purchaseGoldenCardAsync({
        productId,
        email
      });

      dispatch(setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_PAGE }));
      return data.order.id;
    } catch (error: any) {
      setPurchaseCardStep({ step: PurchaseSteps.FAILED });
    }
  }
);

export const purchaseSubscriptionBundle = createAsyncThunk(
  'purchaseSubscriptionBundle',
  async (
    {
      productId,
      email
    }: {
      productId: number;
      email: string;
    },
    { dispatch }
  ) => {
    try {
      const { data } = await purchaseSubscriptionBundleAsync({
        productId,
        email
      });

      dispatch(setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_PAGE }));
      return data.order.id;
    } catch (error: any) {
      setPurchaseCardStep({ step: PurchaseSteps.FAILED });
    }
  }
);

export const purchaseSuperSales = createAsyncThunk(
  'purchaseSuperSales',
  async (
    {
      productId,
      email
    }: {
      productId: number;
      email: string;
    },
    { dispatch }
  ) => {
    try {
      const { data } = await purchaseSuperSalesAsync({
        productId,
        email
      });

      dispatch(setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_PAGE }));
      return data.order.id;
    } catch (error: any) {
      setPurchaseCardStep({ step: PurchaseSteps.FAILED });
    }
  }
);

export const setPurchaseCardStep = createAsyncThunk(
  'setPurchaseCardStep',
  ({ step }: { step: PurchaseSteps }) => {
    return step;
  }
);

export const setOrderId = createAsyncThunk(
  'setOrderId',
  ({ orderId }: { orderId: number }) => {
    return orderId;
  }
);

//VERIFY

export const verifyPayTravelutionMembership = createAsyncThunk(
  'verifyPayTravelutionMembership',
  async ({ orderId }: { orderId: number }) => {
    try {
      const { data } = await axios.post(
        `/products/travelution-memberships/${orderId}/tmt/verify`
      );

      return orderId;
    } catch (error: any) {
      console.log(error);
    }
  }
);

export const verifyPayTravelutionSubscription = createAsyncThunk(
  'verifyPayTravelutionSubscription',
  async ({ orderId }: { orderId: number }) => {
    try {
      const { data } = await axios.post(
        `/products/travelution-subscriptions/${orderId}/tmt/verify`
      );

      return orderId;
    } catch (error: any) {
      console.log(error);
    }
  }
);

export const verifyPayTravelutionGoldenCard = createAsyncThunk(
  'verifyPayTravelutionGoldenCard',
  async ({ orderId }: { orderId: number }) => {
    try {
      const { data } = await axios.post(
        `/products/travelution-golden-cards/${orderId}/tmt/verify`
      );

      return orderId;
    } catch (error: any) {
      console.log(error);
    }
  }
);

export const verifyPayTravelutionBundle = createAsyncThunk(
  'verifyPayTravelutionBundle',
  async ({ orderId }: { orderId: number }) => {
    try {
      const { data } = await axios.post(
        `/products/travelution-subscription-bundles/${orderId}/tmt/verify`
      );

      return orderId;
    } catch (error: any) {
      console.log(error);
    }
  }
);

export const verifySuperSales = createAsyncThunk(
  'verifySuperSales',
  async ({ orderId }: { orderId: number }) => {
    try {
      const { data } = await axios.post(
        `/products/travelution-super-sales/${orderId}/tmt/verify`
      );

      return orderId;
    } catch (error: any) {
      console.log(error);
    }
  }
);

export const verifyPayTravelutionLicence = createAsyncThunk(
  'verifyPayTravelutionLicence',
  async ({ orderId }: { orderId: number }) => {
    try {
      const { data } = await axios.post(
        `/products/backoffice-licences/${orderId}/tmt/verify`
      );

      return orderId;
    } catch (error: any) {
      console.log(error);
    }
  }
);
